import React from "react";
import logo from "../../img/logo.png";
const Header = () => {
  return (
    <div className="center">
      <img src={logo} alt="Logo" />
    </div>
  );
};

export default Header;
